import { render, staticRenderFns } from "./RelatorioVencimentoRoute.vue?vue&type=template&id=491f085e"
import script from "./RelatorioVencimentoRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioVencimentoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports